export class Role {
  public id: string;
  public projectId: string;
  public name: string;
  public permissions: Array<any>;
  public tagRestriction: any;

  constructor(id: string, projectId: string, name: string, permissions: Array<any>, tagRestriction: any) {
    this.id = id;
    this.projectId = projectId;
    this.name = name;
    this.permissions = permissions;
    this.tagRestriction = tagRestriction;
  }
}

namespace app.model.authentication {
  export class Role {
    public id: string;
    public projectId: string;
    public name: string;
    public permissions: Array<any>;
    public tagRestriction: any;


    constructor(id: string, projectId: string, name: string, permissions: Array<any>, tagRestriction: any) {
      this.id = id;
      this.projectId = projectId;
      this.name = name;
      this.permissions = permissions;
      this.tagRestriction = tagRestriction;
    }
  }
}
